<template>
    <div class="com-partm10">
        <MyTitle title="内存高负载服务器" />
        <div class="p-content">
			<div
				v-for="(item, i) in loadList"
				:key="'loadList' + i"
				class="load-list">
				<div class="flex item-t align-center">
					<div class="icon-bg flex justify-center align-center">{{ i + 1 }}</div>
					<div>{{ item.ip }}</div>
				</div>
				<div class="flex item-b  align-center">
					<div class="flex1 item-l">
						<div class="solid" :style="{'width': `${item.percent}%`}"></div>
					</div>
					<div class="flexs flex justify-center item-r">{{ item.num }}GB </div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import { dataInterface } from "@/api/dataInterfaceApi"
// import { formatTime } from '@/utils/index'
export default {
    components: {
        MyTitle,
    },
    data() {
        return {
			loadList: []
        }
    },
	mounted() {
        // 内存高负载服务器
        this.getData()
    },
	methods: {
        // 内存高负载服务器
        getData() {
			let params = { 
				enCode: 'computingpower-right-ncgfzfwq',
			}
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '内存高负载服务器')
                let data = res || []
				this.loadList = data.map((item, i) => {
                    return  {
							ip: item.host,
							num: parseInt(item.memoryLoad, 10),
							percent: parseInt(parseFloat(item.memoryLoad || 0, 10) / 1024 * 100 , 10),
						}
                })
			})
        },
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
</style>